import { SourceType } from 'module/api/filter/types';
import { useMeetingFieldsAsFilterableField } from 'helpers/fields/meeting-fields/fields';
import { meetingBlockResponseToLookup } from '../../../shared/response-renderer-utils';
import { SharedDetailBlockPromptSection } from '../../shared-detail-blocks/prompt-section';
import { MeetingDetailsSectionComponentProps } from '../types';

export const MeetingDetailsPromptSection = ({
  node,
  onDone,
  onRemove,
  onOpen,
  onUndo,
  contentEditable,
  allowResolve,
  pageType,
}: MeetingDetailsSectionComponentProps) => {
  const { fields: meetingFields, loading: isLoading } =
    useMeetingFieldsAsFilterableField();

  return (
    <SharedDetailBlockPromptSection
      node={node}
      sourceType={SourceType.Meeting}
      useFieldsHook={() => ({ fields: meetingFields, loading: isLoading })}
      defaultTitleKey="rich_text_editor_sections_meeting_details"
      titlePlaceholderKey="rich_text_editor_sections_meeting_details_title_placeholder"
      fieldLabelKey="grouped_filter.meeting"
      responseToLookupFunction={meetingBlockResponseToLookup}
      onDone={onDone}
      onUndo={onUndo}
      contentEditable={contentEditable}
      onOpen={onOpen}
      onRemove={onRemove}
      allowResolve={allowResolve}
      pageType={pageType}
    />
  );
};
